import { Alert, Input, Modal, Space } from 'antd'
import { observer } from 'mobx-react-lite'

import { CRM_VERIFICATION_TEXTS as T } from './CrmVerification'

import type { VerificationStore } from './VerificationStore'

/** Межа причини — та сама, що на беку (`comment` ≤ 4096, `SPEC-008` §5.4.1). */
const COMMENT_MAX_LENGTH = 4096

/**
 * «Вкажіть причину відхилення» (`SPEC-009` §8.6, легасі
 * `VerificationCancelModal.jsx:67-79`): одне поле без підпису, обов'язкове.
 * Причина потрапляє в «Коментар до верифікації» картки (КЛ-20), тож
 * «Зберегти» без неї не натиснути.
 */
export const RejectVerificationModal = observer(({ store }: { store: VerificationStore }) => (
    <Modal
        title={T.rejectModalTitle}
        open={store.rejectOpen}
        okText={T.save}
        cancelText={T.close}
        okButtonProps={{ loading: store.pending === 'reject_verification', disabled: !store.canReject }}
        onOk={() => store.submitReject()}
        onCancel={() => store.closeReject()}
        destroyOnHidden
        maskClosable={false}
    >
        <Space orientation="vertical" style={{ width: '100%' }} size="middle">
            {store.rejectError ? <Alert type="error" showIcon title={store.rejectError} /> : null}
            <Input.TextArea
                rows={4}
                maxLength={COMMENT_MAX_LENGTH}
                value={store.rejectComment}
                onChange={(event) => store.setRejectComment(event.target.value)}
            />
        </Space>
    </Modal>
))
